import React, { useState, useEffect } from 'react'
import ApiService from '../services/ApiService'
import { Form, FormGroup, Label, Button, Spinner, Input } from 'reactstrap'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const LANGUAGES = [
	{ code: 'no', name: 'Norsk' },
	{ code: 'en', name: 'English' },
]

const CURRENCIES = [
	{ code: 'NOK', name: 'NOK - Norwegian Krone' },
	{ code: 'SEK', name: 'SEK - Swedish Krona' },
	{ code: 'GBP', name: 'GBP - British Pound' },
	{ code: 'EUR', name: 'EUR - Euro' },
	{ code: 'USD', name: 'USD - US Dollar' },
]

const UserCreationForm = () => {
	const { t } = useTranslation()
	const [tenants, setTenants] = useState([])
	const [loaded, setLoaded] = useState(false)

	// User creation form states
	const [newUserName, setNewUserName] = useState('')
	const [newUserEmail, setNewUserEmail] = useState('')
	const [newUserTenant, setNewUserTenant] = useState(0)
	const [newUserLanguage, setNewUserLanguage] = useState('no')
	const [newUserCurrency, setNewUserCurrency] = useState('NOK')

	useEffect(() => {
		const fetchAllTenants = async () => {
			setLoaded(false)
			const res = await ApiService.getAllTenants()
			const data = res.data
			setTenants(data)
			setLoaded(true)
		}
		fetchAllTenants()
	}, [])

	const handleSubmit = () => {
		const createUser = async () => {
			await ApiService.createUser(
				newUserTenant,
				newUserName,
				newUserEmail,
				newUserLanguage,
				newUserCurrency
			)
		}

		if (newUserName.length && newUserEmail.length && newUserTenant) {
			createUser()
			toast.success('User successfully created.')
			setNewUserEmail('')
			setNewUserName('')
			setNewUserTenant(0)
			setNewUserLanguage('no')
			setNewUserCurrency('NOK')
		} else {
			toast.error('Please make sure all fields are filled in correctly.')
		}
	}

	return (
		<>
			{loaded ? (
				<Form>
					<Label>{t('user_creation_details')}</Label>
					<FormGroup>
						<Input
							type="name"
							name="name"
							placeholder="Full name"
							onChange={(e) => setNewUserName(e.target.value)}
							value={newUserName}
						/>
					</FormGroup>
					<FormGroup>
						<Input
							type="email"
							name="email"
							placeholder="Email"
							onChange={(e) => setNewUserEmail(e.target.value)}
							value={newUserEmail}
						/>
					</FormGroup>
					<Label>{t('user_creation_tenant')}</Label>
					<FormGroup>
						<Input
							type="select"
							name="select"
							onChange={(e) => setNewUserTenant(parseInt(e.target.value))}
							value={newUserTenant}>
							<option hidden>Tenant</option>
							{tenants.map((tenant) => (
								<option key={tenant.id} value={tenant.id}>
									{tenant.id} {tenant.name}
								</option>
							))}
						</Input>
					</FormGroup>
					<Label>{t('user_creation_preferences')}</Label>
					<FormGroup>
						<Input
							type="select"
							name="language"
							onChange={(e) => setNewUserLanguage(e.target.value)}
							value={newUserLanguage}>
							{LANGUAGES.map((lang) => (
								<option key={lang.code} value={lang.code}>
									{lang.name}
								</option>
							))}
						</Input>
					</FormGroup>
					<FormGroup>
						<Input
							type="select"
							name="currency"
							onChange={(e) => setNewUserCurrency(e.target.value)}
							value={newUserCurrency}>
							{CURRENCIES.map((currency) => (
								<option key={currency.code} value={currency.code}>
									{currency.name}
								</option>
							))}
						</Input>
					</FormGroup>
					<Button onClick={() => handleSubmit()}>{t('user_creation_send_email')}</Button>
				</Form>
			) : (
				<>
					<Spinner color="primary" />
				</>
			)}
		</>
	)
}

export default UserCreationForm
